import { defineComponent } from 'vue';
import Banner from '@/components/Banner.vue';
import bannerBg from '@/assets/image/subpage/banner-test.png';
import TestIntroduce from './components/TestIntroduce.vue';
import TestFounder from '@/views/subpage/components/TestFounder.vue';
export default defineComponent({
  components: {
    Banner: Banner,
    TestIntroduce: TestIntroduce,
    TestFounder: TestFounder
  },
  setup: function setup() {
    return {
      bannerBg: bannerBg
    };
  }
});